import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=d579107a&scoped=true&"
import script from "./Submit.vue?vue&type=script&lang=js&"
export * from "./Submit.vue?vue&type=script&lang=js&"
import style0 from "./Submit.vue?vue&type=style&index=0&id=d579107a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d579107a",
  null
  
)

export default component.exports